import { unsubscribeFromNotifications } from './push-notifications';

export default function handleLogout() {
    let logout = () => {
        app.history.push('/');

        app.api.session
            .logout()
            .catch((err) => {
                // ignore all errors
                console.warn(err);
            })
            .then(() => {
                app.store.dispatch(app.actions.session.logout());
                app.shutdown();

                // Clear storage
                localStorage.clear();

                // Reload to remove from memory any user related data
                location.reload();
            });
    };
    app.store.dispatch(app.actions.ui.busy());

    setTimeout(logout, 15000); // escape timeout if hangs unbsubscribing
    unsubscribeFromNotifications()
        .catch((err) => {
            // ignore all errors
            console.warn(err);
        })
        .then(logout);
}
